import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { GlobalFavicon } from './hooks/useSEO';
import ScrollToTop from './components/ScrollToTop/index.js';
import App from "./pages/Home/App.js";
import Login from "./pages/Login/index.js";
import Contato from "./pages/MenuContato/Contato/index.js";
import ContatoNegocio from "./pages/MenuContato/ContatoNegocio/index.js";
import ContatoProblema from "./pages/MenuContato/ContatoProblema/index.js";
import Cadastro from "./pages/Cadastro/index.js";
import PrivateRoute from './private/PrivateRoute.js';
import EsqueciaASenha from './pages/EsqueciaASenha/index.js';
import ResetarSenha from './pages/ResetarSenha/index.js';
import InserirCodigo from './pages/InserirCodigo/index.js';
import Teste from './pages/Teste/index.js';
import ConfirmacaoEmailCodigo from './pages/ConfirmacaoEmailCodigo/index.js';
import CadastroEndereco from './pages/Menu/Perfil/CadastroEndereco/index.js';
import AlterarEndereco from './pages/Menu/Perfil/AlterarEndereco/index.js';
import Manutencao from './pages/Manutencao/index.js';

import Produtos from "./pages/Produtos/index.js";
import VisualizarProdutoCliente from "./pages/VisualizarProduto/index.js";

import Perfil from "./pages/Menu/Perfil/MainPerfil/index.js";
import Favoritos from "./pages/Menu/Perfil/Favoritos/index.js";
import MeusPedidos from './pages/Menu/Perfil/MeusPedidos/index.js';
import DetalhesPedido from './pages/Menu/Perfil/DetalhesPedido/index.js';

import Admin from './pages/Menu/Admin/index.js';
import Dashboard from './pages/Menu/DashBoard/index.js';

import Financeiro from './pages/Menu/Financeiro/MainFinanceiro/index.js';

import Fornecedores from './pages/Menu/Fornecedores/MainFornecedores/index.js';
import CadastroFornecedor from './pages/Menu/Fornecedores/CadastrarFornecedor/index.js';
import EditarFornecedor from './pages/Menu/Fornecedores/EditarFornecedor/index.js';
import VisualizarFornecedor from './pages/Menu/Fornecedores/VisualizarFornecedor/index.js';

import Categorias from './pages/Menu/Categorias/MainCategorias/index.js';
import CadastrarCategoria from './pages/Menu/Categorias/CadastrarCategoria/index.js';
import EditarCategorias from './pages/Menu/Categorias/EditarCategoria/index.js';
import VisualizarCategoria from './pages/Menu/Categorias/VisualizarCategoria/index.js';

import Funcionarios from './pages/Menu/Funcionarios/MainFuncionarios/index.js';
import CadastroFuncionarios from './pages/Menu/Funcionarios/CadastrarFuncionario/index.js';
import EditarFuncionario from './pages/Menu/Funcionarios/EditarFuncionario/index.js';
import VisualizarFuncionario from './pages/Menu/Funcionarios/VisualizarFuncionario/index.js';

import ProdutosEestoque from './pages/Menu/ProdutosEstoque/MainProdutosEstoque/index.js';
import CadastroProduto from './pages/Menu/ProdutosEstoque/CadastroProdutos/index.js';
import EditarProduto from './pages/Menu/ProdutosEstoque/EditarProdutos/index.js';
import VisualizarProduto from './pages/Menu/ProdutosEstoque/VisualizarProdutos/index.js';
import AdicionarEstoque from './pages/Menu/ProdutosEstoque/AdicionarEstoque/index.js';
import PreviewImportacao from './pages/Menu/ProdutosEstoque/PreviewImportacao/index.js';
import EdicaoMassaProdutos from './pages/Menu/ProdutosEstoque/EdicaoMassa/index.js';

import Pedidos from './pages/Menu/Pedidos/MainPedidos/index.js';
import CadastrarPedido from './pages/Menu/Pedidos/CadastrarPedido/index.js';
import EditarPedido from './pages/Menu/Pedidos/EditarPedido/index.js';
import VisualizarPedido from './pages/Menu/Pedidos/VisualizarPedido/index.js';

import MeusPedidosRedirect from './pages/QrCodeRedirect/MeusPedidosRedirect.js';
import AdminPedidosRedirect from './pages/QrCodeRedirect/AdminPedidosRedirect.js';

import Clientes from './pages/Menu/Clientes/MainCliente/index.js';
import CadastrarCliente from './pages/Menu/Clientes/CadastrarCliente/index.js';
import EditarCliente from './pages/Menu/Clientes/EditarCliente/index.js';
import VisualizarCliente from './pages/Menu/Clientes/VisualizarCliente/index.js';

import Cupons from './pages/Menu/Cupons/MainCupons/index.js';
import CadastrarCupom from './pages/Menu/Cupons/CadastrarCupom/index.js';
import EditarCupom from './pages/Menu/Cupons/EditarCupom/index.js';
import VisualizarCupom from './pages/Menu/Cupons/VisualizarCupom/index.js';

import SEO from './pages/Menu/SEO/index.js';
import Impostos from './pages/Menu/Impostos/index.js';

import Checkout from './pages/Checkout/index.js';
import PagamentoRetorno from './pages/PagamentoRetorno/index.js';
import PagamentoConcluido from './pages/PagamentoConcluido/index.js';
import PagamentoPendente from './pages/PagamentoPendente/index.js';
import PagamentoFalhou from './pages/PagamentoFalhou/index.js';
import AvaliacoesSite from './pages/AvaliacoesSite/index.js';
import EscreverAvaliacaoSite from './pages/EscreverAvaliacaoSite/index.js';
import SobreNos from './pages/SobreNos/index.js';
import NaoEncontrado from './pages/NaoEncontrado/index.js';
import PoliticasTrocas from './pages/Institucional/PoliticasTrocas/index.js';
import PoliticasPrivacidade from './pages/Institucional/PoliticasPrivacidade/index.js';
import TermosDeUso from './pages/Institucional/TermosDeUso/index.js';
import FreteEntrega from './pages/Institucional/FreteEntrega/index.js';
import ConfiguracoesPagamento from './pages/Menu/ConfiguracoesPagamento/index.js';
import SalesforceAgentforce from './components/SalesforceAgentforce/index.js';
import FloatingWhatsApp from './components/FloatingWhatsApp/index.js';
import FavoritosPublico from './pages/FavoritosPublico/index.js';

export default function Rotas() {
    return (
        <BrowserRouter>
            <GlobalFavicon />
            <ScrollToTop />
            <SalesforceAgentforce />
            <FloatingWhatsApp />
            <Routes>
                <Route path='/' element={<App />} />
                <Route path='/login' element={<Login />} />
                <Route path='/contato' element={<Contato />} />
                <Route path='/contato/negocio' element={<ContatoNegocio />} />
                <Route path='/contato/problema' element={<ContatoProblema />} />
                <Route path='/cadastro' element={<Cadastro />} />
                <Route path='/esqueciasenha' element={<EsqueciaASenha />} />
                <Route path='/inserir-codigo' element={<InserirCodigo />} />
                <Route path='/confirmacao-email' element={<ConfirmacaoEmailCodigo />} />
                <Route path='/manutencao' element={<Manutencao />} />
                <Route path='/teste' element={<Teste />} />
                <Route path="/resetar-senha/:token" element={<ResetarSenha />} />
                
                {/* QR Code Redirect Routes */}
                <Route path='/meus-pedidos/:id' element={<MeusPedidosRedirect />} />
                <Route path='/admin/pedidos/:id' element={<AdminPedidosRedirect />} />

                <Route path='/sobre-nos' element={<SobreNos />} />
                <Route path='/politicas-trocas' element={<PoliticasTrocas />} />
                <Route path='/politicas-privacidade' element={<PoliticasPrivacidade />} />
                <Route path='/termos-de-uso' element={<TermosDeUso />} />
                <Route path='/frete-e-entrega' element={<FreteEntrega />} />
                <Route path='/favoritos/publico/:token' element={<FavoritosPublico />} />
                <Route path='/produtos' element={<Produtos />} />
                <Route path='/produto/:id' element={<VisualizarProdutoCliente />} />
                <Route path='/avaliacoes-site' element={<AvaliacoesSite />} />
                <Route path='/escrever-avaliacao-site' element={<PrivateRoute element={EscreverAvaliacaoSite} acessosPermitidos={['Usuario', 'Administrador', 'Atacadista', 'Varejista']} />} />
                <Route path='/checkout' element={<PrivateRoute element={Checkout} acessosPermitidos={['Usuario', 'Administrador', 'Entregador', 'Separador', 'AssistenteAtendimento', 'Financeiro', 'Atacadista', 'Varejista']} />} />
                <Route path='/pagamento-retorno' element={<PagamentoRetorno />} />
                <Route path='/pagamento-concluido' element={<PagamentoConcluido />} />
                <Route path='/pagamento-pendente' element={<PagamentoPendente />} />
                <Route path='/pagamento-falhou' element={<PagamentoFalhou />} />
                
                <Route path='/menu/perfil' element={<PrivateRoute element={Perfil} acessosPermitidos={['Usuario', 'Administrador', 'Atacadista', 'Varejista']} />} />
                <Route path='/menu/perfil/cadastroendereco' element={<PrivateRoute element={CadastroEndereco} acessosPermitidos={['Usuario', 'Administrador', 'Atacadista', 'Varejista']} />} />
                <Route path='/menu/perfil/alterarendereco' element={<PrivateRoute element={AlterarEndereco} acessosPermitidos={['Usuario', 'Administrador', 'Atacadista', 'Varejista']} />} />
                <Route path='/menu/perfil/favoritos' element={<PrivateRoute element={Favoritos} acessosPermitidos={['Usuario', 'Administrador', 'Atacadista', 'Varejista']} />} />
                <Route path='/menu/perfil/meuspedidos' element={<PrivateRoute element={MeusPedidos} acessosPermitidos={['Usuario', 'Administrador', 'Atacadista', 'Varejista']} />} />
                <Route path='/menu/perfil/meuspedidos/:id' element={<PrivateRoute element={DetalhesPedido} acessosPermitidos={['Usuario', 'Administrador', 'Atacadista', 'Varejista']} />} />
                
                <Route path='/menu/admin' element={<PrivateRoute element={Admin} acessosPermitidos={['Administrador']} />} />
                
                <Route path='/menu/dashboard' element={<PrivateRoute element={Dashboard} acessosPermitidos={['Administrador']} />} />
                
                <Route path='/menu/financeiro' element={<PrivateRoute element={Financeiro} acessosPermitidos={['Administrador']} />} />
                
                <Route path='/menu/clientes' element={<PrivateRoute element={Clientes} acessosPermitidos={['Administrador']} />} />
                <Route path='/menu/clientes/cadastrocliente' element={<PrivateRoute element={CadastrarCliente} acessosPermitidos={['Administrador']} />} />
                <Route path='/menu/clientes/editarcliente' element={<PrivateRoute element={EditarCliente} acessosPermitidos={['Administrador']} />} />
                <Route path='/menu/clientes/visualizarcliente' element={<PrivateRoute element={VisualizarCliente} acessosPermitidos={['Administrador']} />} />
                
                <Route path='/menu/produtos_e_estoque' element={<PrivateRoute element={ProdutosEestoque} acessosPermitidos={['Administrador']} />} />
                <Route path='/menu/produtos_e_estoque/cadastroproduto' element={<PrivateRoute element={CadastroProduto} acessosPermitidos={['Administrador']} />} />
                <Route path='/menu/produtos_e_estoque/editarproduto' element={<PrivateRoute element={EditarProduto} acessosPermitidos={['Administrador']} />} />
                <Route path='/menu/produtos_e_estoque/visualizarproduto' element={<PrivateRoute element={VisualizarProduto} acessosPermitidos={['Administrador']} />} />
                <Route path='/menu/produtos_e_estoque/adicionar_estoque' element={<PrivateRoute element={AdicionarEstoque} acessosPermitidos={['Administrador']} />} />
                <Route path='/menu/produtos_e_estoque/preview-importacao' element={<PrivateRoute element={PreviewImportacao} acessosPermitidos={['Administrador']} />} />
                <Route path='/menu/produtos_e_estoque/edicao-massa' element={<PrivateRoute element={EdicaoMassaProdutos} acessosPermitidos={['Administrador']} />} />
                
                <Route path='/menu/pedidos' element={<PrivateRoute element={Pedidos} acessosPermitidos={['Administrador']} />} />
                <Route path='/menu/pedidos/cadastropedido' element={<PrivateRoute element={CadastrarPedido} acessosPermitidos={['Administrador']} />} />
                <Route path='/menu/pedidos/editarpedido' element={<PrivateRoute element={EditarPedido} acessosPermitidos={['Administrador']} />} />
                <Route path='/menu/pedidos/visualizarpedido' element={<PrivateRoute element={VisualizarPedido} acessosPermitidos={['Administrador']} />} />
                
                <Route path='/menu/fornecedores' element={<PrivateRoute element={Fornecedores} acessosPermitidos={['Administrador']} />} />
                <Route path='/menu/fornecedores/cadastrofornecedor' element={<PrivateRoute element={CadastroFornecedor} acessosPermitidos={['Administrador']} />} />
                <Route path='/menu/fornecedores/editarfornecedor' element={<PrivateRoute element={EditarFornecedor} acessosPermitidos={['Administrador']} />} />
                <Route path='/menu/fornecedores/visualizarfornecedor' element={<PrivateRoute element={VisualizarFornecedor} acessosPermitidos={['Administrador']} />} />
                
                <Route path='/menu/funcionarios' element={<PrivateRoute element={Funcionarios} acessosPermitidos={['Administrador']} />} />
                <Route path='/menu/funcionarios/cadastrofuncionario' element={<PrivateRoute element={CadastroFuncionarios} acessosPermitidos={['Administrador']} />} />
                <Route path='/menu/funcionarios/editarfuncionario' element={<PrivateRoute element={EditarFuncionario} acessosPermitidos={['Administrador']} />} />
                <Route path='/menu/funcionarios/visualizarfuncionario' element={<PrivateRoute element={VisualizarFuncionario} acessosPermitidos={['Administrador']} />} />
                
                <Route path='/menu/categorias' element={<PrivateRoute element={Categorias} acessosPermitidos={['Administrador']} />} />
                <Route path='/menu/categorias/cadastrarcategoria' element={<PrivateRoute element={CadastrarCategoria} acessosPermitidos={['Administrador']} />} />
                <Route path='/menu/categorias/editarcategoria' element={<PrivateRoute element={EditarCategorias} acessosPermitidos={['Administrador']} />} />
                <Route path='/menu/categorias/visualizarcategoria' element={<PrivateRoute element={VisualizarCategoria} acessosPermitidos={['Administrador']} />} />
                
                <Route path='/menu/cupom' element={<PrivateRoute element={Cupons} acessosPermitidos={['Administrador']} />} />
                <Route path='/menu/cupom/cadastrar' element={<PrivateRoute element={CadastrarCupom} acessosPermitidos={['Administrador']} />} />
                <Route path='/menu/cupom/editar' element={<PrivateRoute element={EditarCupom} acessosPermitidos={['Administrador']} />} />
                <Route path='/menu/cupom/visualizar' element={<PrivateRoute element={VisualizarCupom} acessosPermitidos={['Administrador']} />} />
                
                <Route path='/menu/seo' element={<PrivateRoute element={SEO} acessosPermitidos={['Administrador']} />} />
                <Route path='/menu/impostos' element={<PrivateRoute element={Impostos} acessosPermitidos={['Administrador']} />} />
                <Route path='/menu/configuracoes-pagamento' element={<PrivateRoute element={ConfiguracoesPagamento} acessosPermitidos={['Administrador']} />} />
                
                {/* 404 - Página não encontrada */}
                <Route path='*' element={<NaoEncontrado />} />
            </Routes>
        </BrowserRouter>
    );
}
